import React, { FC } from 'react';
import clsx from 'clsx';

import { RichText } from '@marriott/mi-ui-library';

import { CardArtBadgeProps } from './CardArtBadge.types';
import { StyledCardArtBadge } from './CardArtBadge.styles';
import { CobrandImage } from '../CobrandImage/CobrandImage';

export const CardArtBadge: FC<CardArtBadgeProps> = ({
  badgeDetails,
  imagePath,
  customClass,
  defaultImageText,
  imageClass,
  badgeClass,
  addSpaceToCardArt,
  displayCardArtIcon,
}) => {
  return (
    <StyledCardArtBadge>
      <div className={`d-flex flex-column align-items-center justify-content-center ${customClass}`}>
        {badgeDetails && displayCardArtIcon?.toString() === 'true' && (
          <div>
            <RichText
              customClass={clsx(`t-font-xs m-badge-overlay-merch badge-border-style mx-2 ${badgeClass}`)}
              text={badgeDetails}
              componentId={'card-art-badge'}
            />
          </div>
        )}
        <div className={clsx('text-center img-full-width', addSpaceToCardArt === 'true' && 'mt-4')}>
          <CobrandImage
            defaultImageURL={imagePath}
            altText={defaultImageText ? defaultImageText : 'defaultimagetxt'}
            customClass={imageClass}
          ></CobrandImage>
        </div>
      </div>
    </StyledCardArtBadge>
  );
};
